export default function Rust_Ownership() {
  return (
    <div>
      <h1>Rust_Ownership Component</h1>
      <p>This is the Rust_Ownership page.</p>
    </div>
  );
}
